import { lazy, Suspense } from "react";
import { GlobalLoading } from "../Utils";

const BusinessEvents = lazy(() => import("../Components/ProfilesType/Business/BusinessEvents/BusinessEvents"));
const ResultChart = lazy(() => import("../Components/ProfilesType/Business/BusinessEvents/ResultChart"));
const BusinessHome = lazy(() => import("../Components/ProfilesType/Business/BusinessHome/BusinessHome"));
const MasterPlans = lazy(() => import("../Components/ProfilesType/Business/MasterPlans/MasterPlans"));
const OrganizationDetails = lazy(() => import("../Components/ProfilesType/Business/Organizations/OrganizationDetails"));
const Organizations = lazy(() => import("../Components/ProfilesType/Business/Organizations/Organizations"));
const OrgDashboard = lazy(() => import("../Components/ProfilesType/Business/Organizations/OrgDashboard"));
const OrgSettings = lazy(() => import("../Components/ProfilesType/Business/Organizations/OrgSettings"));
const OrgActivePlans = lazy(() => import("../Components/ProfilesType/Business/Organizations/OrgActivePlans"));
const UseCase = lazy(() => import("../Components/ProfilesType/Business/Organizations/UseCase"));
const Tickets = lazy(() => import("../Components/ProfilesType/Business/Tickets/Tickets"));
const CurrentAll = lazy(() => import("../Components/ProfilesType/Business/Tickets/CurrentAll"))

export const businessRoutes = [
    {
        index: true,
        element: <Suspense fallback={<GlobalLoading />}><BusinessHome /></Suspense>,
    },
    {
        path: "events",
        element: <Suspense fallback={<GlobalLoading />}><BusinessEvents /></Suspense>,
    },
    {
        path: "result-chart",
        element: <Suspense fallback={<GlobalLoading />}><ResultChart /></Suspense>,
    },
    {
        path: "organizations",
        element: <Suspense fallback={<GlobalLoading />}><Organizations /></Suspense>,
    },
    {
        path: "organizations/:id",
        element: <Suspense fallback={<GlobalLoading />}><OrganizationDetails /></Suspense>,
        children: [
            {
                index: true,
                element: <Suspense fallback={<GlobalLoading />}><OrgDashboard /></Suspense>,
            },
            {
                path: "dashboard",
                element: <Suspense fallback={<GlobalLoading />}><OrgDashboard /></Suspense>,
            },
            {
                path: "settings",
                element: <Suspense fallback={<GlobalLoading />}><OrgSettings /></Suspense>,
            },
            {
                path: "active-plans",
                element: <Suspense fallback={<GlobalLoading />}><OrgActivePlans /></Suspense>,
            },
            {
                path: "active-plans/use-case",
                element: <Suspense fallback={<GlobalLoading />}><UseCase /></Suspense>,
            },
        ],
    },
    {
        path : "master-plans",
        element : <Suspense fallback={<GlobalLoading />}><MasterPlans /></Suspense>
    },
    {
        path : "tickets",
        element : <Suspense fallback={<GlobalLoading />}><Tickets /></Suspense>
    },
    {
        path : "tickets/current-all",
        element : <Suspense fallback={<GlobalLoading />}><CurrentAll /></Suspense>
    },
]